import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
	auth: {
		clientId: 'b8509cf3-a75d-4db4-b283-425ce3ab3c61',
		authority:
			'https://login.microsoftonline.com/7fb3a2b6-1d35-4810-87df-eec11a5de209',
		redirectUri: window.location.origin,
		navigateToLoginRequestUrl: false
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false
	},
	system: {
		allowNativeBroker: true
	}
};

export const scopes = [
	'openid',
	'profile',
	'api://b8509cf3-a75d-4db4-b283-425ce3ab3c61/access_as_user',
	'User.Read',
	'offline_access'
];
